import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { InvoiceStatuses } from '@app/base/invoices-base';
import { Currency } from '@app/common/settings';
import { HashMap } from 'utils';

@Component({
  selector: 'vshcz-invoice-item',
  templateUrl: './invoice-item.component.html',
  styleUrls: [ './invoice-item.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceItemComponent {

  invoiceStatuses = InvoiceStatuses;

  @Input()
  id: string;

  @Input()
  number: string;

  @Input()
  totalDue: number;

  @Input()
  currencyId: string;

  @Input()
  created: string;

  @Input()
  dueDate: string;

  @Input()
  paidDate: string;

  @Input()
  daysOverdue: number;

  @Input()
  status: InvoiceStatuses;

  @Input()
  priceSize = 20;

  @Input()
  symbolSize = 15;

  @Input()
  currencyMap: HashMap<Currency>;
}
